export default "__VITE_ASSET__2b90694e__"